/**
 * RTWO Cryptography & Identity Engine — HSM Key Provider (Scaffold)
 */

import { ScaffoldKeyProvider } from './scaffold-key-provider';

export class HsmKeyProvider extends ScaffoldKeyProvider {
  readonly providerId = 'hsm-key-provider';
  readonly providerName = 'HSM Key Provider';
  readonly providerType = 'hsm' as const;
  readonly scaffoldMessage =
    'HSM key provider scaffold. Hardware security module connection not implemented — cryptographic operations unavailable.';
}
